import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import RoachHomepage from "../components/RoachHomepage";

const IndexPage = (props) => {
  const homePageNode = props.data?.allContentfulPage?.edges?.[0]?.node || {};

  return (
    <Layout
      pageProps={props}
      footerLogoShowcase={false}
      isHomePage
      headerTransparent={false}
      headerShadow={false}
    >
      <SEO
        title={homePageNode.metaTitle || "Roofing & Home Improvement in West Michigan"}
        description={
          homePageNode.metaDescription ||
          "Roach Home Improvement provides roofing, siding, windows, doors, storm restoration, and financing throughout West Michigan."
        }
        keywords={homePageNode.metaKeywordsList || []}
      />
      <RoachHomepage />
    </Layout>
  );
};

export default IndexPage;

export const pageQuery = graphql`
  {
    allContentfulPage(filter: { slug: { eq: "home" } }, limit: 1) {
      edges {
        node {
          metaTitle
          metaDescription
          metaKeywordsList
        }
      }
    }
  }
`;
